import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, TextInput } from "@/components/common/Forms";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (password !== confirm) return setError("Le due password non coincidono");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    }
  };
  return (
    <AuthShell>
      <p className="eyebrow mb-4">Nuova password</p>
      <h1 className="text-4xl font-light">Scegli la tua nuova password.</h1>
      {!params.get("token") ? (
        <div data-testid="reset-invalid-link" className="mt-8 space-y-6">
          <p className="text-sm text-warm-text">Questo link non è valido. Richiedine uno nuovo: ti arriverà via email.</p>
          <Link to="/password-dimenticata" className="btn-gold w-full">Richiedi un nuovo link</Link>
        </div>
      ) : done ? (
        <div data-testid="reset-password-done" className="mt-8 space-y-6">
          <p className="text-sm text-warm-text">Fatto. Ora puoi accedere con la nuova password.</p>
          <Link to="/accedi" className="btn-gold w-full">Accedi</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-6">
          <Field label="Nuova password" hint="Almeno 8 caratteri"><TextInput data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
          <Field label="Ripeti la password"><TextInput data-testid="reset-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></Field>
          {error && <p data-testid="reset-error" className="text-sm text-destructive">{error}</p>}
          <button data-testid="reset-submit-btn" className="btn-gold w-full">Salva la password</button>
        </form>
      )}
    </AuthShell>
  );
}
